import axios from 'axios'

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const BASE_CLASS_URL = `${BASE_URL}api/classes`;

const BulkClassService = () => ({

    getClasses: async (filters, token) => {
        const { data } = await axios.get(`${BASE_CLASS_URL}`, {
            params: {
                ...filters
            },
            cancelToken: token
        });
        return data;
    },
    updateClassMapping: async (className, classGroupId, newClassGroupId, displayLabel) => {
        const { status } = await axios.put(`${BASE_CLASS_URL}/ClassMapping`, { className, classGroupId, newClassGroupId, displayLabel });
        return status;
    },
});

export default BulkClassService;